import { useEffect, useState } from "react";

interface SplashScreenProps {
  /** Minimum time (ms) to show the splash before fading out */
  duration?: number;
  onFinish?: () => void;
}

const SplashScreen = ({ duration = 1400, onFinish }: SplashScreenProps) => {
  const [fading, setFading] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), duration);
    const hideTimer = setTimeout(() => {
      setHidden(true);
      onFinish?.();
    }, duration + 500);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, [duration, onFinish]);

  if (hidden) return null;

  return (
    <div
      aria-hidden="true"
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-mint-light transition-opacity duration-500 ${
        fading ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="flex flex-col items-center gap-4 animate-fade-in">
        <div className="text-4xl sm:text-6xl font-extrabold tracking-tight text-mint-foreground">
          Hound Payments
        </div>
        <div className="text-sm sm:text-base font-medium text-mint-foreground/80 tracking-wide uppercase">
          Get paid direct
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
